import React from 'react';
import PropTypes from 'prop-types';
import { Container } from './styles';
import Image from '../Image';

const Language = ({ handleLanguage, languagesOpts }) => (
  <Container>
    { languagesOpts.map(item => (
      <li key={item.id} onClick={() => handleLanguage(item.value)}>
        <Image
          src={item.flag}
          alt={item.alt}
        />
      </li>
    ))}
  </Container>
);

Language.propTypes = {
  handleLanguage: PropTypes.func,
  languagesOpts: PropTypes.array
};

export default Language;
